<section class="hero hero-bar">
  <div class="container-points-and-search">
    <div class="container-points">
      <p class="title">Troca de pontos</p>
      <div class="box-points">
        <p class="paragraph">{{ 'clicStore.myPoints' | translate}}</p>
        <div class="points-box">{{points ? points : '0'}}</div>
      </div>
    </div>

    <div class="container-search">
      <p class="paragraph">{{ 'search' | translate}}</p>
      <div class="input-box">
        <input type="text" placeholder="{{ 'clicStore.searchProducts02' | translate}}" [(ngModel)]="searchBuyProductInput.name">
        <button class="icon" (click)="onSearch()">
          <img src="assets/images/magnifying-glass.svg" alt="">
        </button>
      </div>
    </div>
  </div>
</section>

<section class="clic-extracts">
  <h1>Histórico de trocas</h1>

  <div class="history">
    <div>
      <p>Histórico</p>

      <div class="divider"></div>

      <button (click)="onChangeTableVisibility()" type="button">
        <img src="assets/images/arrow-{{tableIdVisible ? 'up' : 'down'}}.svg" alt="">
      </button>
    </div>
  </div>

  <div [ngClass]="!buys.length ? 'not-found' : ''" class="table">
    <table *ngIf="tableIdVisible && buys.length" class="table table_regular">
      <thead>
      <tr>
          <th scope="col" class="text-blue-normal">Data</th>
          <th scope="col" class="text-blue-normal">Descrição</th>
          <th scope="col" class="text-blue-normal"></th>
          <th scope="col" class="text-blue-normal">Status</th>
          <th scope="col" class="text-green">{{points}} pts</th>
      </tr>
      </thead>
      <tbody>
          <tr *ngFor="let buy of buys">
              <td class="text-blue-normal">{{buy.createdAt | date: 'dd/MM/yyyy'}}</td>
              <td class="text-blue">{{buy.awards.name}}</td>
              <td class="btn-eye" (click)="onOpenModal(buy)">
                <img src="assets/images/eye-secondary.svg" alt="">
              </td>
              <td class="status" [ngClass]="buy.status ? buy.status : ''">{{changeName(buy?.status)}}</td>
              <td class="text-red"> - {{buy.awards.value}} pts </td>
          </tr>
      </tbody>
    </table>
    <p class="not-found" *ngIf="!buys?.length">{{ 'exchangesNotFound' | translate}}</p>
  </div>

</section> 

<div *ngIf="isModalVisible" class="modal-overlay" (click)="onCloseModal()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <header>
      <h2>Detalhes</h2>
      <button (click)="onCloseModal()" class="close-modal">
        <img src="assets/images/close-modal-secondary.svg" alt="">
      </button>
    </header>
    <div class="modal-body">
      <div>
        <p class="text-gray">Descrição do produto</p>
        <p class="text-blue">{{modelBuys.awards.name}}</p>
      </div>

      <div>
        <p class="text-gray">Quantidade:</p>
        <p class="text-blue">{{modelBuys.quantity}} unidades</p>
      </div>

      <div>
        <p class="text-gray">Troca realizada em:</p>
        <p class="text-blue">{{modelBuys.createdAt | date: 'dd/MM/yyyy \'às\' HH:mm:ss'}}</p>
      </div>

      <div>
        <p class="text-gray">Quantidade de pontos debitados</p>
        <p class="text-red">{{modelBuys.awards.value}} pontos</p>
      </div>

      <div>
        <p class="text-gray">Status da compra</p>
        <p [ngClass]="modelBuys.status ? modelBuys.status : ''">{{changeName(modelBuys.status)}}</p>
      </div>
    </div>
    <div *ngIf="modelBuys.status === 'Pending'" class="modal-buttons">
      <button class="cancel" (click)="onCancelBuy()">Cancelar Compra</button>
    </div>
  </div>
</div>